import React from 'react'
import { observer } from 'mobx-react'

function ValidationError (props) {

  if (typeof props.is_valid === 'boolean' && props.is_valid === true) {
    return null
  } // If valid then don't show error

  return (
    <div className={'validation-error input-box'}>
      {props.children}
    </div>
  )
}

export default observer(ValidationError)